export const useKeyboard = () => {
  const escapePressedTimestamp = { value: 0 }

  const useDoubleEscape = (action) => {
    const doubleEscapeEventListener = window.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return

      if ((Date.now() - escapePressedTimestamp.value) < 500) {
        action()
      } else {
        escapePressedTimestamp.value = Date.now()
      }
    })

    return () => window.removeEventListener('keydown', doubleEscapeEventListener)
  }

  return {
    useDoubleEscape
  }
}
